<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title v-if="mode==='create'">Create Store Remark and Special Status</md-dialog-title>
      <md-dialog-title v-if="mode==='update'">Change Store Remark and Special Status</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave">

          <template v-if="mode==='create'">
            <calling-api type="bar" path="/api/w/stores">
              <div :class="getValidationClass('dataForm.storeId')">
                <auto-complete-search-store-multiple-select
                    ref="SelectStore"
                    label="Store"
                    :mulpitle="false"
                    :init-selected-id="dataForm.storeId"
                    :on-store-selected="handleStoreChanged">
                </auto-complete-search-store-multiple-select>
                <div class="md-error" v-if="!$v.dataForm.storeId.required">Store is required</div>
              </div>
            </calling-api>
          </template>
          <template v-else>
            <md-field>
              <label>Store Id</label>
              <md-input disabled v-model="dataForm.storeId"/>
            </md-field>
          </template>

          <div :class="getValidationClass('dataForm.startDate')">
            <datepicker v-model="dataForm.startDate">
              <label>Start date</label>
            </datepicker>
            <div class="md-error" v-if="!$v.dataForm.startDate.required">Start date is required</div>
          </div>

          <div :class="getValidationClass('dataForm.endDate')">
            <datepicker v-model="dataForm.endDate">
              <label>End date</label>
            </datepicker>
            <div class="md-error" v-if="!$v.dataForm.endDate.required">End date is required</div>
          </div>

          <md-field :class="getValidationClass('dataForm.storeTimeFrom')">
            <label>Store Time From</label>
            <md-input v-model="dataForm.storeTimeFrom"/>
            <!--<div class="md-error" v-if="!$v.dataForm.storeTimeFrom.required">Store Time From is required</div>-->
            <div class="md-error" v-if="!$v.dataForm.storeTimeFrom.validateTime">Store Time should be in HH:mm format
            </div>
          </md-field>

          <br/>

          <md-field :class="getValidationClass('dataForm.storeTimeTo')">
            <label>Store Time To</label>
            <md-input v-model="dataForm.storeTimeTo"/>
            <!--<div class="md-error" v-if="!$v.dataForm.storeTimeTo.required">Store Time To is required</div>-->
            <div class="md-error" v-if="!$v.dataForm.storeTimeTo.validateTime">Store Time should be in HH:mm format
            </div>
          </md-field>

          <br/>

          <div :class="getValidationClass('dataForm.haulerId')">
            <auto-complete-master-data-select
                group="Hauler"
                label="Haulier"
                :init-value-id="dataForm.haulerId"
                :on-item-changed="handleHaulerChanged">
            </auto-complete-master-data-select>
            <div class="md-error" v-if="!$v.dataForm.haulerId.required">Haulier is required</div>
          </div>

          <calling-api type="bar" path="/api/w/users">
            <div :class="getValidationClass('dataForm.dispatcherId')">
              <auto-complete-master-data-select
                  :prepared-options="dispatchers"
                  label="Dispatcher"
                  :init-value="getDispatcherInitValue"
                  :watch-value-id="dataForm.dispatcherId"
                  :on-item-changed="handleDispatcherChanged">
              </auto-complete-master-data-select>
              <div class="md-error" v-if="!$v.dataForm.dispatcherId.required">Dispatcher is required</div>
            </div>
          </calling-api>

          <div :class="getValidationClass('dataForm.endOutletIds')">
            <auto-complete-master-data-multiple-select
                ref="SelectEndOutlet"
                group="EndOutlet"
                label="End outlet(s)"
                :init-selected-ids="getEndOutletsInitValue"
                :on-selected-item-ids-changed="handleEndOutletsChanged">
            </auto-complete-master-data-multiple-select>
            <div class="md-error" v-if="!$v.dataForm.endOutletIds.isNotEmpty">End Outlet(s) is required</div>
          </div>

          <div :class="getValidationClass('dataForm.endOutletId')">
            <auto-complete-master-data-select
                group="EndOutlet"
                label="Default End Outlet"
                :prepared-options="getSelectedEndOutletOptions"
                :init-value-id="dataForm.endOutletId"
                :on-item-changed="handleEndOutletChanged">
            </auto-complete-master-data-select>
            <div class="md-error" v-if="!$v.dataForm.endOutletId.required">Default End Outlet is required</div>
          </div>

          <div :class="getValidationClass('dataForm.statusId')">
            <auto-complete-master-data-select
                group="StoreSpecialStatus"
                label="Special Status"
                :init-value-id="dataForm.statusId"
                :on-item-changed="handleSpecialStatusChanged">
            </auto-complete-master-data-select>
            <div class="md-error" v-if="!$v.dataForm.statusId.required">Status is required</div>
          </div>


          <md-field :class="getValidationClass('dataForm.driverRemark')">
            <label>Driver Remark</label>
            <md-input v-model="dataForm.driverRemark"/>
            <div class="md-error" v-if="!$v.dataForm.driverRemark.required">Driver Remark is required</div>
          </md-field>

          <br/>

          <div :class="getValidationClass('dataForm.routeId')">
            <auto-complete-master-data-select
                group="RouteID"
                label="Route"
                :init-value-id="dataForm.routeId"
                :on-item-changed="handleRouteChanged">
            </auto-complete-master-data-select>
            <div class="md-error" v-if="!$v.dataForm.routeId.required">Route is required</div>
          </div>


          <div :class="getValidationClass('dataForm.driverGroup')">
            <driver-group-select
                label="Driver Group"
                v-model="dataForm.driverGroup">
            </driver-group-select>
            <div class="md-error" v-if="!$v.dataForm.driverGroup.required">Driver Group is required</div>
          </div>

          <div :class="getValidationClass('dataForm.day')">
            <label>Pickup Weekday (1~7, Mon~Sun)</label>

            <div>
              <md-checkbox :key="d" v-for="d in 7" v-model="dataForm.days" :value="d">{{d | weekDayDisplay}}</md-checkbox>
            </div>

            <!--<div class="md-error" v-if="!$v.dataForm.days.required">Pickup Weekday is required</div>-->
          </div>

          <calling-api path="/api/w/stores/getOne" type="bar">
            <div v-if="store">
              <master-data-select
                  v-if="store.pickUpTypeId==='ZE'"
                  group="EndOutletMilkRun1"
                  label="Transloading Point"
                  v-model="dataForm.transloadingPoint"
              />
              <master-data-select
                  v-if="store.pickUpTypeId==='ZF'"
                  group="EndOutletMilkRun2"
                  label="Transloading Point"
                  v-model="dataForm.transloadingPoint"
              />
            </div>
          </calling-api>

          <calling-api type="bar" path="/api/w/stores/special/action">

            <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>

          </calling-api>


        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import validateTime from '../utils/validate-time';
  import { required } from 'vuelidate/lib/validators';

  const getInitialDataForm = () => {
    return {
      storeId: null,
      storeName: null,
      statusId: null,
      statusName: null,
      driverRemark: null,
      startDate: null,
      endDate: null,
      storeTimeFrom: null,
      storeTimeTo: null,
      dispatcherId: null,
      dispatcherName: null,
      endOutletId: null,
      endOutletIds: [],
      haulerId: null,
      haulerName: null,
      routeId: null,
      routeDesc: null,
      driverGroup: null,
      day: null,
      days: [],
      createdAt: null,
      createdBy: null,
      transloadingPoint: null,
    };
  };

  export default {
    mixins: [validationMixin],
    props: {
      mode: String,
    },
    data: () => ({
      showDialog: false,
      dispatchers: [],
      dataForm: getInitialDataForm(),
      storeSpecialIdBeforeUpdate: {
        storeId: null,
        startDate: null,
      },
      store: null,
    }),
    computed: {
      ...mapGetters([
        'getMasterDataAsSelectOptionByGroup',
        'getMasterDataByGroup',
        'getMasterDataName',
      ]),
      getDispatcherInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.dispatcherName} (${this.dataForm.dispatcherId})`
      },
      getSpecialStatusInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.statusName} (${this.dataForm.statusId})`
      },
      getEndOutletsInitValue(){
        if (this.mode === 'create') {
          return null;
        }
        return this.dataForm.endOutletIds;
      },
      getSelectedEndOutletOptions(){
        const allEndOutlets = this.getMasterDataAsSelectOptionByGroup('EndOutlet');
        const endOutletIds = this.dataForm.endOutletIds || [];
        return _(allEndOutlets).filter(it => _(endOutletIds).contains(it.id));
      },
    },
    watch: {
      'dataForm.haulerId'(val) {
        this.dispatchers = [];
        //api.post('/api/w/users', { category: 'B', companyId: val }).then((res) => {
        newAPIPost('/api/w/users', { category: 'B', companyId: val }).then((res) => {
          this.dispatchers = _(res)
            .filter(it => it.disabled !== true)
            .map(it => ({
              id: it.username,
              name: it.name,
            }));
          console.log(JSON.stringify(this.dispatchers));
          if (!_(this.dispatchers).find(it => it.id === this.dataForm.dispatcherId)) {
            this.dataForm.dispatcherId = null;
            this.dataForm.dispatcherName = null;
          }
        });
      },
      'dataForm.storeId'(val) {
        if (!val) {
          this.store = null;
          this.dataForm.transloadingPoint = null;
        }
      },
    },
    validations: {
      dataForm: {
        storeId: {
          required,
        },
        statusId: {},
        statusName: {},
        driverRemark: {},
        startDate: {
          required,
        },
        endDate: {
          required,
        },
        storeTimeFrom: {
          // required,
          validateTime(val) {
            if (val) {
              return validateTime(val);
            }
            return true;
          },
        },
        storeTimeTo: {
          // required,
          validateTime(val) {
            if (val) {
              return validateTime(val);
            }
            return true;
          },
        },
        dispatcherId: {
          required,
        },
        dispatcherName: {
          required,
        },
        haulerId: {
          required,
        },
        endOutletIds: {
          isNotEmpty(v){
            if (v) {
              return v.length > 0
            }
            return false;
          },
        },
        endOutletId: {
          required,
        },
        haulerName: {
          required,
        },
        routeId: {},
        driverGroup: {
          required,
        },
        // day: {
        //   required,
        //   minValue: minValue(1),
        //   maxValue: maxValue(7)
        // },
      },
    },
    methods: {
      openDialog(existingData) {
        this.$v.dataForm.$reset();
        this.dataForm = getInitialDataForm();
        console.log(`openDialog`, existingData);
        if (existingData && this.mode === 'update') {
          this.dataForm.storeId = existingData.storeId;
          this.dataForm.statusId = existingData.statusId;
          this.dataForm.statusName = existingData.statusName;
          this.dataForm.driverRemark = existingData.driverRemark;
          this.dataForm.startDate = existingData.startDate;
          this.dataForm.endDate = existingData.endDate;
          this.dataForm.storeTimeFrom = existingData.storeTimeFrom;
          this.dataForm.storeTimeTo = existingData.storeTimeTo;
          this.dataForm.dispatcherId = existingData.dispatcherId;
          this.dataForm.dispatcherName = existingData.dispatcherName;
          this.dataForm.endOutletId = existingData.endOutletId;
          this.dataForm.endOutletIds = existingData.endOutletIds;
          this.dataForm.transloadingPoint = existingData.transloadingPoint;
          this.dataForm.haulerId = existingData.haulerId;
          this.dataForm.haulerName = existingData.haulerName;
          this.dataForm.createdAt = existingData.createdAt;
          this.dataForm.routeId = existingData.routeId;
          this.dataForm.routeDesc = existingData.routeDesc;
          this.dataForm.driverGroup = existingData.driverGroup;
          this.dataForm.day = existingData.day;
          this.dataForm.days = existingData.days;
          this.dataForm.createdAt = existingData.createdAt;
          this.dataForm.createdBy = existingData.createdBy;

          this.storeSpecialIdBeforeUpdate.storeId = existingData.storeId;
          this.storeSpecialIdBeforeUpdate.startDate = existingData.startDate;

          this.store = existingData.storeDto;
        }

        this.showDialog = true;
      },
      getValidationClass(fieldName) {
        const field = _(this.$v).lookup(fieldName)

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      handleStoreChanged(storeId) {
        console.log(`handleStoreChanged`, storeId);
        this.dataForm.storeId = storeId;

        //api.post(`/api/w/stores/getOne`, { storeId }).then(store => {
        newAPIPost(`/api/w/stores/getOne`, { storeId }).then(store => {
          this.store = store;
          this.dataForm.transloadingPoint = null;
        })
      },
      handleDispatcherChanged(id, name) {
        this.dataForm.dispatcherId = id;
        this.dataForm.dispatcherName = name;
      },
      handleHaulerChanged(id, name) {
        this.dataForm.haulerId = id;
        this.dataForm.haulerName = name;
      },
      handleEndOutletChanged(id) {
        this.dataForm.endOutletId = id;
      },
      handleSpecialStatusChanged(id, name) {
        this.dataForm.statusId = id;
        this.dataForm.statusName = name;
      },
      handleRouteChanged(id, name) {
        this.dataForm.routeId = id;
        this.dataForm.routeDesc = name;
      },
      handleEndOutletsChanged(endOutletIds) {
        this.dataForm.endOutletIds = endOutletIds;
      },
      doSave() {
        this.$v.dataForm.$touch();

        if (this.$v.dataForm.$invalid) {
          return;
        }

        const createOperation = () => {
          this.$store
            .dispatch(
              `doActionOnStoreSpecial`,
              {
                action: this.mode,
                storeSpecialDto: this.dataForm,
              }
            )
            .then(() => {
              this.showDialog = false;
            })
            .then(() => {
              this.$store.dispatch('loadStoreSpecials')
            });
        };

        if (this.mode === 'update') {
          this.$store
            .dispatch(
              `doActionOnStoreSpecial`,
              {
                action: 'delete',
                storeSpecialDto: this.storeSpecialIdBeforeUpdate,
              }
            )
            .then(() => {
              createOperation()
            });
        } else {
          createOperation();
        }


      }
    }
  }
</script>
